
import './App.css';
import { router, } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React from 'react'
import { PlanProvider } from './Components/PlanContext';
import { LogoProvider } from './Components/LogoContext';
import { HorarioProvider } from './Components/HorarioContext';
import { ThemeProvider } from './Components/ThemeContext';
import ServicioSuspendido from './Components/ServicioSuspendido';


function App() {


  return (
    <ThemeProvider>
      <PlanProvider>
        <LogoProvider>
          <HorarioProvider>
            <ServicioSuspendido>
              <RouterProvider router={router} />
            </ServicioSuspendido>
          </HorarioProvider>
        </LogoProvider>
      </PlanProvider>
    </ThemeProvider>
  );
}

export default App;
